import { useTranslation } from 'react-i18next'

import Text from '../../Text'
import {
  getFieldVariableDescription,
  getFieldVariableUsages,
} from '../FieldVariable.utils'
import { FieldVariableCopyButton } from '../FieldVariableCopyButton'

import * as styles from './FieldVariableCardItem.module.css'

function FieldVariableCardItem({
  fieldVariable: { description, label, used_in: usedIn },
}) {
  const { i18n, t } = useTranslation()

  const descriptionText = getFieldVariableDescription({ description, i18n, t })
  const usages = getFieldVariableUsages({ t, usedIn })

  return (
    <div className={styles.FieldVariableCardItem}>
      <div className={styles.variable}>
        <div className={styles.labelContainer}>
          <Text isSecondary className={styles.label}>
            {label}
          </Text>
        </div>
        <FieldVariableCopyButton value={label} />
      </div>
      {descriptionText || usages ? (
        <div className={styles.details}>
          {descriptionText ? <Text isSecondary>{descriptionText}</Text> : null}
          {usages ? (
            <Text isSecondary>{t('FieldVariable.UsedInKey', { usages })}</Text>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}

export default FieldVariableCardItem
